import './../../css/ShowInfo.css'
import {useSelector} from "react-redux";

export const ShowInfo = ({title, message, discountCode, setIsDiscountCodeModalOpen}) => {

    const traceId = useSelector(state => state.Token.traceId);

    return(
        <>
            {
                discountCode ?
                    <div className='row w-100 justify-content-between'>
                        <div className={`col-12 col-md-6`}>
                            <p className="mb-1 me-3 mt-4 me-lg-4 show-info-title">{title}</p>
                            <p className="show-info-text me-3 me-lg-4">{message}</p>
                        </div>

                        <div className={`col-12 col-md-5 d-flex justify-content-start`}>

                            <div className={`d-flex justify-content-center align-items-center px-3 pe-md-5`}>
                                <button className='btn traceIdDiv'
                                    onClick={ () => setIsDiscountCodeModalOpen(true)}
                                >کد تخفیف</button>
                            </div>
                            <div className='me-3 me-md-0 col-md-3 d-flex align-items-center'>
                                <div className={`traceIdDiv`}>
                                    <span className={`traceIdSpan`}>کد پیگیری</span>
                                    {traceId}
                                </div>
                            </div>

                        </div>


                    </div>
                    :
                    traceId ?
                    <div className='row w-100 justify-content-between'>
                        <div className={`col-12 col-md-9`}>
                            <p className="mb-1 me-3 mt-4 me-lg-4 show-info-title">{title}</p>
                            <p className="show-info-text me-3 me-lg-4">{message}</p>
                        </div>
                        <div className='col-6 me-3 me-md-0 col-md-3 d-flex align-items-center'>
                            <div className={`traceIdDiv`}>
                                <span className={`traceIdSpan`}>کد پیگیری</span>
                                {traceId}
                            </div>
                        </div>

                    </div>
                    :

                    <>
                        <p className="mb-1 me-3 mt-4 me-lg-4 show-info-title">{title}</p>
                        <p className="show-info-text me-3 me-lg-4">{message}</p>
                    </>
            }

        </>
    )
}
